"use client";

import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  FullScreen,
  type FullScreenProps,
  useFullScreenHandle,
} from "react-full-screen";
import s from "./FullscreenContent.module.scss";

export default function FullscreenContent(
  props: Omit<FullScreenProps, "handle">,
) {
  const { children, ...restProps } = props;
  const handle = useFullScreenHandle();

  const handleFullScreen = () => {
    if (handle.active) {
      handle.exit();
    } else {
      handle.enter();
    }
  };

  return (
    <FullScreen handle={handle} {...restProps}>
      <div className={s.wrapper}>
        <div className={s.controlBar}>
          <button
            className={s.iconButton}
            onClick={handleFullScreen}
            aria-label={handle.active ? "Exit fullscreen" : "Enter fullscreen"}
          >
            {handle.active ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </button>
        </div>
        {children}
      </div>
    </FullScreen>
  );
}
